import React, { useEffect, useState, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import { useLocation, useHistory, Redirect } from "react-router-dom";
import { Modal as bots } from "bootstrap";
import $ from "jquery";
import moment from "moment";
import ico_add_img from "../../static/images/ico-add_img.svg";
import { Modal } from "react-bootstrap";


const ValidacionesR = Yup.object().shape({

  description: Yup.string()
    .required("No puede estar vacio")
    .min(3, "No puede tener menos de 3 caracteres")
    .max(255, "No puede tener mas de 255 caracteres"),
  startDate: Yup.date()
  .transform(function (value, originalValue) {
    if (this.isType(value)) {
      return value;
    }
    const result = moment(originalValue, "DD/MM/YYYY HH:mm").toDate();
    return result;
  })
  .typeError("La fecha no es valida")
  .required("Se requiere una fecha")
  .min(new Date(), "El evento no puede ser en el pasado"),

  endDate: Yup.date()
  .transform(function (value, originalValue) {
    if (this.isType(value)) {
      return value;
    }
    const result = moment(originalValue, "DD/MM/YYYY HH:mm").toDate();
    return result;
  })
  .typeError("La fecha no es valida")
  .required("Se requiere una fecha")
  .min(new Date(), "El evento no puede ser en el pasado")
  .min(Yup.ref("startDate"), "La fecha de finalizacion debe ser mayor a la fecha de inicio"),

  name: Yup.string()
    .required("No puede estar vacio")
    .min(3, "No puede tener menos de 3 caracteres")
    .max(255, "No puede tener mas de 255 caracteres"),
  contactName: Yup.string()
    .required("No puede estar vacio")
    .min(3, "No puede tener menos de 3 caracteres")
    .max(255, "No puede tener mas de 255 caracteres"),
  contactPhone: Yup.string()
    .required("No puede estar vacio")
    .min(3, "No puede tener menos de 8 caracteres")
    .max(255, "No puede tener mas de 255 caracteres"),
    website: Yup.string()
    .required("No puede estar vacio"),
    place: Yup.string()
    .required("No puede estar vacio"),
});

const Eventos = ({ data, setShow = () => null, setUpdateEventList }) => {
  const location = useLocation();
  const [imgPortada, setimgPortada] = useState("");
  const [banner, setbanner] = useState("");
  const [showImgPortada, setshowImgPortada] = useState("");
  const [showBanner, setshowBanner] = useState("");
  const handleClosePortada = () => setShowPortada(false);
  const handleClosePerfil = () => setShowPerfil(false);
  const [iniitalValues, setInitialValues] = useState([]);
  const [showPortada, setShowPortada] = useState(false);
  const [showPerfil, setShowPerfil] = useState(false);
  const [redirect, setRedirect] = useState(false)
  const history = useHistory();

  const setMin = () => {
    var today = moment(Date.now()).format("YYYY-MM-DDTHH:mm");
    document.getElementById("startDate").setAttribute("min", today);
    document.getElementById("endDate").setAttribute("min", today);
  };
  useEffect(() => {
    const event = location.state;
    setRedirect(event?.redirect)
    setMin()
    if (event != null) {
      var startDate = moment(event.item.startDate).format("YYYY-MM-DDTHH:mm");
      var endDate = moment(event.item.endDate).format("YYYY-MM-DDTHH:mm");
      event.item.startDate = startDate;
      event.item.endDate = endDate;
      setInitialValues(event.item);
      setbanner(event.item.image);
      setimgPortada(event.item.coverImage);
      history.replace();
    }
  }, []);

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("tok");

  function ActualizarPortada() {
    let portada = document.getElementById("bannerImageEventUpdate");
    if (portada.files[0] != undefined) {
      setimgPortada(portada.files[0]);
      setshowImgPortada(URL.createObjectURL(portada.files[0]));
      portada.value = "";
      $("#actualizar-portada-modal").modal("hide");
    } else {
      toast.error("Elija una imagen");
    }
    setShowPortada(false);
  }

  const ActualizarPerfil = () => {
    const perfil = document.getElementById("profileImageEventUpdate");

    if (perfil.files[0] != undefined) {
      setbanner(perfil.files[0]);
      setshowBanner(URL.createObjectURL(perfil.files[0]));
      perfil.value = "";
      $("#exampleModal").modal("hide");
    } else {
      toast.error("Elija una imagen");
    }
    setShowPerfil(false);
  };

  const callmodal = (show) => {
    const mod = new bots(document.getElementById("exampleModal"));
    show ? mod.show() : mod.hide();
  };

  function postEvento(values, resetForm) {
    let perfil = document.getElementById("profileImageEventUpdate");
    let rol = localStorage.getItem("rol");
    let urlEndPoint = "";
    var startDate = moment(values.startDate)
      .format("DD/MM/YYYY HH:mm")
      .replaceAll("/", "-");
    var endDate = moment(values.endDate)
      .format("DD/MM/YYYY HH:mm")
      .replaceAll("/", "-");
    if (rol === "company" || rol === "institute")
      urlEndPoint = "exclusive-events";

    // all the other validation is done in yup.
    // we need to validate that imgPortada and banner are
    // 1 - not empty 2 - Files with the image type
    if (imgPortada == "" || imgPortada ==null ) {
      toast.error("Debe seleccionar una portada");
      return;
    }
    if (banner == "" || banner ==null) {
      toast.error("Debe seleccionar una imagen de perfil");
      return;
    }
    if (imgPortada.type.indexOf("image") == -1) {
      toast.error("Debe seleccionar una imagen para la portada");
      return;
    }
    if (banner.type.indexOf("image") == -1) {
      toast.error("Debe seleccionar una imagen para el perfil");
      return;
    }
    let formData = new FormData();
    formData.append("contactName", values.contactName);
    formData.append("description", values.description);
    formData.append("place", values.place);
    formData.append("endDate", endDate);
    formData.append("startDate", startDate);
    formData.append("name", values.name);
    formData.append("contactPhone", values.contactPhone);
    formData.append("website", values.website);

    if (banner != iniitalValues.image) {
      formData.append("image", banner);
    }

    if (imgPortada != iniitalValues.coverImage) {
      formData.append("coverImage", imgPortada);
    }

    let config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    };
    if (Object.keys(iniitalValues).length > 0) {
      axios
        .put("/exclusive-events/" + values.id, formData, config)
        .then((result) => {
          if (result.status == 200) {
            resetForm(true);
            setimgPortada(null);
            setshowImgPortada(null);
            setbanner(null);
            setshowBanner(null);
            toast.success(
              "Evento actualizado"
            );
            
          }
        });
      setInitialValues([]);
      setbanner("");
      setimgPortada("");

    } else {
      axios
        .post(urlEndPoint, formData, config)
        .then((result) => {
          if (result.status === 201) {
            setUpdateEventList(values)
            resetForm(true);
            setimgPortada(null);
            setshowImgPortada(null);
            setbanner(null);
            setshowBanner(null);
            toast.success("Evento creado");
          }
        })
        .catch(function (error) {
          if (error?.response?.status === 399) {
            toast.error(
              "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
            );
            setTimeout(() => {
              history.push("/");
            }, 5000);
          }
          if (error?.response?.status === 400) {
            toast.error(error.response.data.message);
          }
        });
    }

    setShow(false);
    history.replace();
    if (redirect) {

      setTimeout(() => {
        history.push('/company/perfil')
      }, 1000)
    }

  }

  let rol = localStorage.getItem("rol");
  let pathComplement = "";
  if (rol === "company") pathComplement = "/company";
  else pathComplement = "/CentroFormacion";



  return (
    <Fragment>
      
      <div className="content" style={{ width: "100%" }}>
        <div className="tab-content" id="pills-tabContent">
          <div className="mb-3 row">
            <div className="profile__cover-photo ">
              <img
                id="coverImage"
                name="image"
                className="no-cover-image"
                src={showImgPortada == "" ? imgPortada : showImgPortada}
                style={{
                  maxHeight: "1380px",
                  maxWidth: "1300px",
                  width: "100%",
                  height: "100%",
                  borderRadius: "10px",
                }}
              ></img>
              <button
                onClick={(e) => setShowPortada(true)}
                className="btn btn--gradient"
              >
                Portada
              </button>
            </div>
          </div>
          <div className="profile__header-info">
            <div className="profile__header-info-left">
              <div className="row d-flex align-items-end">
                <div className="col-12 col-md-3 d-flex justify-content-center">
                  <div className="profile__header-info-photo">
                    <button
                      onClick={(e) => setShowPerfil(true)}
                      className="btn btn--white"
                    >
                      <img
                        src={
                          banner == ""
                            ? ico_add_img
                            : showBanner == ""
                              ? banner
                              : showBanner
                        }
                        alt="Añadir imagen"
                        style={
                          banner != "" || showBanner != ""
                            ? {
                              width: "147px",
                              height: "136px",
                              borderRadius: "9px",
                              marginLeft: "-41px",
                              marginTop: "-40px",
                            }
                            : {}
                        }
                      ></img>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-tab2"
          >
            <Formik
              enableReinitialize={true}
              initialValues={{
                image: iniitalValues.image ?? "",
                coverImage: iniitalValues.coverImage ?? "",
                contactPhone: iniitalValues.contactPhone ?? "",
                description: iniitalValues.description ?? "",
                name: iniitalValues.name ?? "",
                startDate: iniitalValues.startDate ?? "",
                endDate: iniitalValues.endDate ?? "",
                contactName: iniitalValues.contactName ?? "",
                website: iniitalValues.website ?? "",
                id: iniitalValues.id ?? "",
                place: iniitalValues.place ?? "",
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                postEvento(values, resetForm);
                setSubmitting(false);

              }}
              validationSchema={ValidacionesR}
            >
              {({ errors, touched, isSubmitting }) => (
                <Form>
                  <div className="mb-3 row">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label for="name" className="col-sm-2 col-form-label">
                          Nombre
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="name"
                            className="form-control"
                            id="name"
                          ></Field>
                          {errors.name && touched.name && (
                            <span className="form__validation form__validation--error">
                              {errors.name}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <label
                          for="website"
                          className="col-sm-4 col-form-label"
                        >
                          WebSite:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="website"
                            className="form-control"
                            id="website"
                          ></Field>
                          {errors.website && touched.website && (
                            <span className="form__validation form__validation--error">
                              {errors.website}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-11 mb-3">
                        <label for="place" className="col-sm-2 col-form-label">
                          Dirección
                        </label>
                        <div className="col-sm-12">
                          <Field
                            as="textarea"
                            name="place"
                            id="place"
                            className="form-control"
                            maxLength={255}
                            required
                          ></Field>
                          {errors.place && touched.place && (
                            <span className="form__validation form__validation--error">
                              {errors.place}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="startDate"
                          className="col-sm-4 col-form-label"
                        >
                          Fecha de Inicio:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="datetime-local"
                            name="startDate"
                            className="form-control"
                            id="startDate"
                          ></Field>
                          {errors.startDate && touched.startDate && (
                            <span className="form__validation form__validation--error">
                              {errors.startDate}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="endDate"
                          className="col-sm-6 col-form-label"
                        >
                          Fecha Finalización:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="datetime-local"
                            name="endDate"
                            className="form-control"
                            id="endDate"
                          ></Field>
                          {errors.endDate && touched.endDate && (
                            <span className="form__validation form__validation--error">
                              {errors.endDate}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row"></div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label
                          for="contactName"
                          className="col-sm-6 col-form-label"
                        >
                          Nombre de Contacto:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="contactName"
                            id="contactName"
                            className="form-control"
                          ></Field>
                          {errors.contactName && touched.contactName && (
                            <span className="form__validation form__validation--error">
                              {errors.contactName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <label
                          for="contactPhone"
                          className="col-sm-6 col-form-label"
                        >
                          Número de Contacto:
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="contactPhone"
                            id="contactPhone"
                            className="form-control"
                          ></Field>
                          {errors.contactPhone && touched.contactPhone && (
                            <span className="form__validation form__validation--error">
                              {errors.contactPhone}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5"></div>
                    <div className="row mt-5">
                      <div className="col-12 col-md-12">
                        <h6>Descripción</h6>
                        <div className="m-st">
                          <Field
                            as="textarea"
                            name="description"
                            id="description"
                            maxLength={255}
                            className="form-control"
                            required
                          ></Field>
                          {errors.description && touched.description && (
                            <span className="form__validation form__validation--error">
                              {errors.description}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5">
                      <div className="col-12 col-md-12">
                        <div className="form__row">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--gradient btn__icon btn__icon--door"
                          >
                            Guardar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      
      <Modal
        show={showPortada}
        keyboard={false}
        dialogClassName="kr-modal"
        onHide={handleClosePortada}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__description text-center">
                Seleccione una portada
              </div>
              <div className="form__row">
                <div className="col-sm-12 col-md-8">
                  <label htmlFor="bannerImageEventUpdate">Banner</label>
                  <input
                    id="bannerImageEventUpdate"
                    type="file"
                    accept="image/*"
                    required
                  ></input>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={ActualizarPortada}
            className="btn btn--gradient btn__icon btn__icon--door"
            style={{ color: "white" }}
          >
            Actualizar Portada
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPerfil}
        keyboard={false}
        dialogClassName="kr-modal"
        onHide={handleClosePerfil}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__description text-center">
                Seleccione una imagen
              </div>
              <div className="col-sm-12 col-md-6">
                <label for="name">Imagen Perfil</label>
                <div className="file">
                  <i className="fas fa-images"></i> Elegir archivo
                  <input
                    type="file"
                    id="profileImageEventUpdate"
                    accept="image/*"
                  />
                </div>
                <small className="green">Archivo Seleccionado</small>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={ActualizarPerfil}
            className="btn btn--gradient btn__icon btn__icon--door"
            style={{ color: "white" }}
          >
            Subir Perfil
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default Eventos;
